import React from "react";
import { LoginState } from "../../types/CommonInterfaces";

export const LoginStateContext = React.createContext<[LoginState, (value: LoginState) => void]>([{ loggedIn: false }, (value: LoginState) => 0]);